import React, { Component } from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';

import { request, reportErrorToHoneybadger, handleRequestErrors } from '../helpers/Requests'

import ModalContainerTrigger from '../components/shared/ModalContainerTrigger'
import NoticeBox from '../components/shared/NoticeBox';
import HelpText from '../components/help/HelpText';

import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { spaceAndCapitalize, adminUser, setIdAndMethod, renderErrorWarning, renderErrors } from '../utilities/Forms.js'
import { renderPlannedEventOrAppointment, formatNewLines, truncate } from '../utilities/Generic.js'
import Audits from '../components/shared/Audits';

class UserForm extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleApiKeys = this.toggleApiKeys.bind(this);
    this.confirmPasswordReset = this.confirmPasswordReset.bind(this);
    this.cancelPasswordReset = this.cancelPasswordReset.bind(this);
    this.requestPasswordReset = this.requestPasswordReset.bind(this)
    this.requestPasswordResetLink = this.requestPasswordResetLink.bind(this)
    this.cycleApiKeys = this.cycleApiKeys.bind(this);
    this.showEmail = this.showEmail.bind(this);
    this.hideEmail = this.hideEmail.bind(this);
  }

  state = {
    first_name: "",
    last_name: "",
    email: "",
    access_levels: [],
    external_sign_on_only: false,
    email_opt_out: [],
    location_ids: [],
    fire_log_location_ids: [],
    customer_api: false,
    locations: [],
    inactive: false,
    emails: [],

    passwordResetConfirmationModal: false,
    resettingPassword: false,
    resetPasswordLink: "",

    plannedEventOrAppointment: renderPlannedEventOrAppointment(),
    selectedEmail: null,
    showEmails: false,

    redirect: false,
    updating: false,
    loaded: false,
    locationsLoaded: false,
    emailsLoaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleCheckbox(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState({[name]: value});
  }

  handleMultiCheckbox(event) {
    const useInteger = event.target.dataset.useInteger === "true";
    const flipped = event.target.dataset.flipped === "true";

    const name = useInteger ? parseInt(event.target.name) : event.target.name;
    const value = flipped ? !event.target.checked : event.target.checked;
    const key = event.target.dataset.key;

    var state = this.state[key]

    if (value === true) {
      if (!state.includes(name)) {
        state.push(name)
      }
    }
    else if (value === false) {
      if (state.includes(name)) {
        const index = state.indexOf(name)
        state.splice(index, 1)
      }
    }

    this.setState({[key]: state});

    if (this.state.current_user === true && localStorage.getItem("access_levels").includes("admin")) {
      if (name === "admin" && value === false) {
        this.setState({"errors": {"access_level": ["You cannot remove Admin access from yourself"]}});
      }
      else if (name === "admin" && value === true) {
        this.setState({"errors": ""});
      }
    }
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = {
      "user": {
        "first_name": this.state.first_name,
        "last_name": this.state.last_name,
        "email": this.state.email,
        "access_level": this.state.access_levels,
        "external_sign_on_only": this.state.external_sign_on_only,
        "email_opt_out": this.state.email_opt_out,
        "twenty_four_hour_times": this.state.twenty_four_hour_times,
        "location_ids": this.state.location_ids,
        "fire_log_location_ids": this.state.fire_log_location_ids,
        "inactive": this.state.inactive
      }
    }

    if (this.props.mode === "create") {
      json.user.customer_api = this.state.customer_api
    }

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/users/${id}`, JSON.stringify(json), () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `User ${this.props.mode}d successfully!`);

        if (this.props.mode === "create") {
          this.setState({ id: data.id, redirect: true })
        }
        else if (this.props.mode === "update") {
          if (parseInt(this.props.id) === 0) {
            // Trigger the popup and reset the form for Reporting and Emergency users
            // who load the form without a slide-in panel.
            this.setState({ updating: false })
            this.props.updatePopupCallback(Math.random())
          }

          this.props.closeEditPanel()
        }
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  requestPasswordReset(event) {
    this.setState({ resettingPassword: true, passwordErrors: "" })

    var json = JSON.stringify({
      "password_reset": {
        "email_address": this.state.saved_email,
      }
    })

    request('POST', '/v1/a/users/request_password_reset', json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          resettingPassword: false,
          passwordResetConfirmationModal: false,
          passwordErrors: ""
        })

        sessionStorage.setItem("updateSuccess", "Password Reset Email requested successfully!");
        this.props.updatePopupCallback(this.props.id);
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ resettingPassword: false, error: error })
        }
        else {
          this.setState({ resettingPassword: false, passwordErrors: error })
        }
      })

    event.preventDefault();
  }

  requestPasswordResetLink(event) {
    let id = this.props.id;

    this.setState({resettingPassword: true})
    this.setState({passwordErrors: ""})

    request('POST', `/v1/a/users/${id}/request_password_reset_link`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          resetPasswordLink: data.reset_link,
          resettingPassword: false
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ resettingPassword: false, error: error })
        }
        else {
          this.setState({ resettingPassword: false, passwordErrors: error })
        }
      })

    event.preventDefault();
  }

  confirmPasswordReset(event) {
    this.setState({
      passwordResetConfirmationModal: true,
      passwordErrors: ""
    })
  }

  cancelPasswordReset() {
    this.setState({
      passwordResetConfirmationModal: false
    })
  }

  showEmail(event) {
    const id = event.currentTarget.id;
    const email = this.state.emails.find(email => email.id === parseInt(id))

    this.setState({ selectedEmail: email });

    event.preventDefault();
  }

  hideEmail(event) {
    this.setState({ selectedEmail: null })
  }

  toggleApiKeys(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState({[name]: value});

    request('POST', `/v1/a/users/${this.props.id}/toggle_api_keys`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          customer_api: data.customer_api,
          primary_key: data.primary_key,
          secondary_key: data.secondary_key,
          primary_key_valid_until: data.primary_key_valid_until,
          secondary_key_valid_until: data.secondary_key_valid_until
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ resettingPassword: false, error: error })
        }
        else {
          this.setState({ resettingPassword: false, errors: error })
        }
      })

    event.preventDefault();
  }

  cycleApiKeys(event) {
    request('POST', `/v1/a/users/${this.props.id}/cycle_api_keys`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          primary_key: data.primary_key,
          secondary_key: data.secondary_key,
          primary_key_valid_until: data.primary_key_valid_until,
          secondary_key_valid_until: data.secondary_key_valid_until
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ resettingPassword: false, error: error })
        }
        else {
          this.setState({ resettingPassword: false, errors: error })
        }
      })

    event.preventDefault();
  }

  renderPasswordConfirmationModal() {
    if (this.state.passwordResetConfirmationModal) {
      return (
        <div className="send-email-container">
          <div className="send-email-content">
            <label className="column">Request a password reset email to be sent to this address?</label>
            <div className="center"><strong>{this.state.saved_email}</strong></div>
            {this.renderUnsavedEmailChangeNotice()}
            <div className="grid-2-centered-columns">
              <div/>
              <button className="send-email-button" value="yes" onClick={this.requestPasswordReset} disabled={this.state.resettingPassword}>Request Email</button>
              {adminUser() && (<button className="send-email-button" value="link" onClick={this.requestPasswordResetLink} disabled={this.state.resettingPassword}>Request Link</button>)}
              <button className="send-email-button" value="no" onClick={this.cancelPasswordReset} disabled={this.state.resettingPassword}>Cancel</button>
              <div/>
            </div>

            {this.state.resetPasswordLink && (
              <div className="reset-password-link">
                <div className="center">Reset password link:</div>
                <input value={this.state.resetPasswordLink} readOnly />
              </div>
            )}

            {this.state.passwordErrors &&
            <div>
              <div className="top-padding"/>
              {this.state.passwordErrors.errors.map((error, index) => (
                <div className="error" key={index}>{error}</div>
              ))}
            </div>
            }
          </div>
        </div>
      )
    }
  }

  renderUnsavedEmailChangeNotice() {
    if (this.state.email.trim().toLowerCase() !== this.state.saved_email.trim().toLowerCase()) {
      return (
        <div className="red-text">Note: if you wish to send the password reset email to a different address, you must save it first.</div>
      )
    }
  }

  renderSaveButton() {
    if (adminUser() || parseInt(this.props.id) === 0) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderFireLogLocationsSelection(assigned_locations, fire_log_location_ids) {
    if (assigned_locations.length > 0) {
      return (
        <table className="checkbox-table bottom-margin">
          <tbody>
            <tr>
              <th>Name</th>
              <th>Send Emergency Fire Log Emails?</th>
            </tr>
            {assigned_locations.map((location) => (
              <tr key={location.id}>
                <td>
                  <Link to={`/location/${location.id}`}>{location.name}</Link>
                </td>
                <td className="center-cell">
                  <input className="column" type="checkbox" data-name={"fire_log" + location.name} name={location.id} data-key="fire_log_location_ids" data-use-integer="true" checked={fire_log_location_ids.includes(location.id)} onChange={this.handleMultiCheckbox} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )
    }
    else {
      return (
        <NoticeBox type={"info"} text={"Only assigned Locations can be added as Fire Log Locations!"} />
      )
    }
  }

  renderEmailStatus(email) {
    let status = "Processed";

    if (email.dropped.length > 0) status = "Dropped";
    if (email.deferred.length > 0) status = "Deferred";
    if (email.bounced.length > 0) status = "Bounced";
    if (email.delivered.length > 0) status = "Delivered";

    return status
  }

  render() {
    const { first_name, last_name, email, access_levels, external_sign_on_only, email_opt_out, location_ids, fire_log_location_ids, customer_api, twenty_four_hour_times, inactive, locations, plannedEventOrAppointment, emails, selectedEmail, showEmails, loaded, locationsLoaded, emailsLoaded, id, redirect, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/settings/users/${id}`}/>
    }

    if (loaded === false || locationsLoaded === false || emailsLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded && locationsLoaded && emailsLoaded) {
      const baseLicense = localStorage.license === "base"
      const slimForm = parseInt(this.props.id) === 0

      return (
        <div>
          <form className="settings big-settings segment-settings" onSubmit={this.handleSubmit}>
            {slimForm === false && (
              <div className="segment">
                <div className="row">
                  <HelpText page={'user'} section={'firstName'} />

                  <label className="column">First Name:</label>{ renderErrors(errors, 'first_name') }
                  <input className="column" type="text" name="first_name" value={first_name} onChange={this.handleChange} />
                </div>

                <div className="row">
                  <HelpText page={'user'} section={'lastName'} />

                  <label className="column">Last Name:</label>{ renderErrors(errors, 'last_name') }
                  <input className="column" type="text" name="last_name" value={last_name} onChange={this.handleChange} />
                </div>

                <div className="row">
                  <HelpText page={'user'} section={'email'} />

                  <label className="column">Email Address:</label>{ renderErrors(errors, 'email') }
                  <input className="column" type="email" name="email" value={email} onChange={this.handleChange} />
                </div>

                <div className="row">
                  <HelpText page={'user'} section={'accessLevel'} plannedEventOrAppointment={plannedEventOrAppointment} />

                  <label className="column">Access Level:</label>{ renderErrors(errors, 'access_level') }
                  <table className="checkbox-table">
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <th>Enable</th>
                      </tr>
                      {["admin", "manager", "reporting", "emergency", "email_receiver"].map((access_level) => (
                        <tr key={access_level}>
                          <td>
                            {spaceAndCapitalize(access_level)}
                          </td>
                          <td className="center-cell">
                            <input className="column" type="checkbox" name={access_level} data-key="access_levels" checked={access_levels.includes(access_level)} onChange={this.handleMultiCheckbox} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="segment" id="email_preferences">
              <div className="row">
                <label className="column">Email preferences:</label>
                { renderErrors(errors, 'email_opt_out') }
              </div>

              {baseLicense && (
                <div className="row">
                  <HelpText page={'user'} section={'critical_emails'} />

                  <input className="column small-bottom-margin" type="checkbox" name="critical" id="critical" data-key="email_opt_out" data-flipped="true" checked={!email_opt_out.includes("critical")} onChange={this.handleMultiCheckbox} />
                  <label className="column checkbox-label" htmlFor="critical">Receive critical alerts?</label>
                </div>
              )}

              <div className="row">
                <HelpText page={'user'} section={'product_emails'} />

                <input className="column small-bottom-margin" type="checkbox" name="product" id="product" data-key="email_opt_out" data-flipped="true" checked={!email_opt_out.includes("product")} onChange={this.handleMultiCheckbox} />
                <label className="column checkbox-label" htmlFor="product">Receive product updates?</label>{ renderErrors(errors, 'receive_critical_alerts') }
              </div>

              <div className="row">
                <HelpText page={'user'} section={'marketing_emails'} />

                <input className="column small-bottom-margin" type="checkbox" name="marketing" id="marketing" data-key="email_opt_out" data-flipped="true" checked={!email_opt_out.includes("marketing")} onChange={this.handleMultiCheckbox} />
                <label className="column checkbox-label" htmlFor="marketing">Receive marketing emails?</label>{ renderErrors(errors, 'receive_critical_alerts') }
              </div>

              <div className="row">
                <HelpText page={'user'} section={'feature_usage_emails'} />

                <input className="column small-bottom-margin" type="checkbox" name="feature_usage" id="feature_usage" data-key="email_opt_out" data-flipped="true" checked={!email_opt_out.includes("feature_usage")} onChange={this.handleMultiCheckbox} />
                <label className="column checkbox-label" htmlFor="feature_usage">Receive feature usage emails?</label>{ renderErrors(errors, 'receive_critical_alerts') }
              </div>
            </div>

            <div className="segment">
              <div className="row">
                <HelpText page={'user'} section={'twenty_four_hour_times'} />

                <input className="column small-bottom-margin" type="checkbox" name="twenty_four_hour_times" id="twenty_four_hour_times" checked={twenty_four_hour_times} onChange={this.handleCheckbox} />
                <label className="column checkbox-label" htmlFor="twenty_four_hour_times">View times in 24 hour format?</label>{ renderErrors(errors, 'twenty_four_hour_times') }
              </div>
            </div>

            {slimForm === false && (
              <div className="segment">
                <div className="row">
                  <HelpText page={'user'} section={'locations'} />

                  <label className="column">Locations:</label>{ renderErrors(errors, 'location') }
                  <table className="checkbox-table">
                  <tbody>
                      <tr>
                        <th>Name</th>
                        <th>Allow Access?</th>
                      </tr>
                      {locations.map((location) => (
                        <tr key={location.id}>
                          <td>
                            <Link to={`/location/${location.id}`}>{location.name}</Link>
                          </td>
                          <td className="center-cell">
                            <input className="column" type="checkbox" data-name={location.name} name={location.id} data-key="location_ids" data-use-integer="true" checked={location_ids.includes(location.id)} onChange={this.handleMultiCheckbox} />
                          </td>
                        </tr>
                      ))}
                      </tbody>
                  </table>
                </div>

                {baseLicense && (
                  <div className="row">
                    <HelpText page={'user'} section={'fire_log_locations'} />

                    <label className="column">Fire Log Locations:</label>{ renderErrors(errors, 'fire_log_location') }
                    {this.renderFireLogLocationsSelection(locations.filter(location => location_ids.includes(location.id)), fire_log_location_ids)}
                  </div>
                )}
              </div>
            )}

            {slimForm === false && (
              <div className="segment">
                <div className="row">
                  <HelpText page={'user'} section={'external_sign_on_only'} />

                  <input className="column small-bottom-margin" type="checkbox" name="external_sign_on_only" id="external_sign_on_only" checked={external_sign_on_only} onChange={this.handleCheckbox} />
                  <label className="column checkbox-label" htmlFor="external_sign_on_only">SSO required?</label>{ renderErrors(errors, 'external_sign_on_only') }
                </div>

                <div className="row">
                  <HelpText page={'user'} section={'customer_api'} />

                  <input className="column small-bottom-margin" type="checkbox" name="customer_api" id="customer_api" checked={customer_api} onChange={this.props.mode === "create" ? this.handleCheckbox : this.toggleApiKeys} />
                  <label className="column checkbox-label" htmlFor="customer_api">Enable Customer API?</label>{ renderErrors(errors, 'customer_api') }

                  {this.props.mode === "create" && customer_api && (
                    <NoticeBox type={"info"}>API Keys will be generated once the new User is created. Check back to this section after saving.</NoticeBox>
                  )}
                </div>

                {customer_api && this.state.primary_key &&
                  <div className="row">
                    <label className="column">Customer API:</label>{ renderErrors(errors, 'primary_key') } { renderErrors(errors, 'secondary_primary_key') }
                    <div className="table big-table small-bottom-margin">
                      <div className="tr heading">
                        <div className="th">Type</div>
                        <div className="th">Key</div>
                        <div className="th">Expiry</div>
                        <div className="th">Refresh</div>
                      </div>
                      <div className="tr">
                        <div className="td">Primary</div>
                        <div className="td"><input className="input-in-table" value={this.state.primary_key} readOnly /></div>
                        <div className="td">{this.state.primary_key_valid_until}</div>
                        <div className="td">
                          <div className="button button-in-table small" onClick={this.cycleApiKeys}>
                            Cycle keys
                          </div>
                        </div>
                      </div>
                      <div className="tr">
                        <div className="td">Secondary</div>
                        <div className="td"><input className="input-in-table" value={this.state.secondary_key} readOnly /></div>
                        <div className="td">{this.state.secondary_key_valid_until}</div>
                        <div className="td">
                          <div className="button button-in-table small" onClick={this.cycleApiKeys}>
                            Cycle keys
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="right-container">
                      <Link className="cool-button" to={{ pathname: "https://digital-reception.github.io/customer-api-docs/" }} target="_blank">
                        <h4>Customer API Documentation</h4>
                        <FontAwesomeIcon icon={faFilePdf} />
                      </Link>
                    </div>
                  </div>
                }

                <div className="row">
                  <HelpText page={'user'} section={'inactive'} />

                  <input className="column small-bottom-margin" type="checkbox" name="inactive" id="inactive" checked={inactive} onChange={this.handleCheckbox} disabled={this.state.current_user} />
                  <label className="column checkbox-label" htmlFor="inactive">Inactive?</label>{ renderErrors(errors, 'inactive') }
                </div>

                {this.props.mode === "update" &&
                  <div className="row">
                    <HelpText page={'user'} section={'email_password_reset'} />
                    <div className="green-button" id={this.props.id} onClick={this.confirmPasswordReset}>Email Password Reset</div>
                    {this.renderPasswordConfirmationModal()}
                  </div>
                }
              </div>
            )}

            <div className="segment">
              { this.renderSaveButton() }
              { renderErrorWarning(errors) }
            </div>
          </form>

          {showEmails && (
            <div>
              <h3 className="inline-block margin-right">Emails</h3>

              <div className="table big-table">
                <div className="tr heading">
                  <div className="th">Subject</div>
                  <div className="th">Body</div>
                  <div className="th">Date</div>
                  <div className="th">Status</div>
                </div>
                {emails.map((email) => (
                  <div onClick={this.showEmail} id={email.id} key={email.id} className="tr email clickable">
                    <div className="td">{truncate(email.subject, 20)}</div>
                    <div className="td">{truncate(email.body, 40)}</div>
                    <div className="td">{email.processed[0]?.timestamp || email.dropped[0]?.timestamp}</div>
                    <div className="td">{this.renderEmailStatus(email)}</div>
                  </div>
                ))}
              </div>

              {emails.length === 0 && (
                <div className="long-tr">
                  <div className="long-td">
                    No recent emails.
                  </div>
                </div>
              )}

              <ModalContainerTrigger full={true} showModal={selectedEmail !== null} closeModal={this.hideEmail}>
                {selectedEmail !== null && (
                  <div>
                    <h3>Email delivery details</h3>
                    <p>
                      <strong>Subject</strong>
                      <p className="email-details">{selectedEmail.subject}</p>
                    </p>
                    <p>
                      <strong>Body</strong>
                      <p className="email-details">{formatNewLines(selectedEmail.body)}</p>
                    </p>
                    {selectedEmail.processed.length > 0 && (
                      <p>
                        <strong>Processed</strong>
                        {selectedEmail.processed.map((processed, index) =>
                          <p key={index} className="email-details">
                            <span className="bold">Timestamp</span>: {processed.timestamp}
                          </p>
                        )}
                      </p>
                    )}
                    {selectedEmail.dropped.length > 0 && (
                      <p>
                        <strong>Dropped</strong>
                        {selectedEmail.dropped.map((dropped, index) =>
                          <p key={index} className="email-details">
                            <div><span className="bold">Timestamp</span>: {dropped.timestamp}</div>
                            <div><span className="bold">Reason</span>: {dropped.reason}</div>
                          </p>
                        )}
                      </p>
                    )}
                    {selectedEmail.deferred.length > 0 && (
                      <p>
                        <strong>Deferred</strong>
                        {selectedEmail.deferred.map((deferred, index) =>
                          <p key={index} className="email-details">
                            <div><span className="bold">Timestamp</span>: {deferred.timestamp}</div>
                            <div><span className="bold">Response</span>: {deferred.response}</div>
                          </p>
                        )}
                      </p>
                    )}
                    {selectedEmail.bounced.length > 0 && (
                      <p>
                        <strong>Bounced</strong>
                        {selectedEmail.bounced.map((bounced, index) =>
                          <p key={index} className="email-details">
                            <div><span className="bold">Timestamp</span>: {bounced.timestamp}</div>
                            <div><span className="bold">Reason</span>: {bounced.reason}</div>
                          </p>
                        )}
                      </p>
                    )}
                    {selectedEmail.delivered.length > 0 && (
                      <p>
                        <strong>Delivered</strong>
                        {selectedEmail.delivered.map((delivered, index) =>
                          <p key={index} className="email-details">
                            <div><span className="bold">Timestamp</span>: {delivered.timestamp}</div>
                            <div><span className="bold">Response</span>: {delivered.response}</div>
                          </p>
                        )}
                      </p>
                    )}
                  </div>
                )}
              </ModalContainerTrigger>
            </div>
          )}

        { this.props.mode === "update" && <Audits klass="User" id={this.props.id} /> }
        </div>
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.history.location.hash === "") {
      return
    }
    if (prevState.initialAnchorScroll === true) {
      return
    }

    const anchor = this.props.history.location.hash.substring(1)
    const anchorElement = document.getElementById(anchor)

    if (anchorElement) {
      this.setState({ initialAnchorScroll: true })
      anchorElement.scrollIntoView()
    }
  }

  componentDidMount() {
    const id = this.props.id;

    if (this.props.mode === "create") {
      this.setState({ loaded: true, emailsLoaded: true, showEmails: false })
    }
    else {
      request('GET', `/v1/a/users/${id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            saved_email: data.email,
            access_levels: data.access_level,
            external_sign_on_only: data.external_sign_on_only,
            email_opt_out: data.email_opt_out,
            location_ids: data.location_ids,
            fire_log_location_ids: data.fire_log_location_ids,
            customer_api: data.customer_api,
            twenty_four_hour_times: data.twenty_four_hour_times,
            inactive: data.inactive,
            current_user: data.current_user,
            loaded: true
          })

          if (data.customer_api === true) {
            this.setState({
              primary_key: data.primary_key,
              secondary_key: data.secondary_key,
              primary_key_valid_until: data.primary_key_valid_until,
              secondary_key_valid_until: data.secondary_key_valid_until
            })
          }
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })

      if (id === 0 || id === "0") {
        request('GET', `/v1/a/users/0/emails`, null, () => { this.setState({ unauthorized: true }) })
          .then(data => { this.setState({ emails: data, emailsLoaded: true, showEmails: true }) })
          .catch(error => { handleRequestErrors(this, error, { emailsLoaded: true }) })
      }
      else if (adminUser()) {
        // Only Admins can read other peoples emails
        request('GET', `/v1/a/users/${id}/emails`, null, () => { this.setState({ unauthorized: true }) })
          .then(data => { this.setState({ emails: data, emailsLoaded: true, showEmails: true }) })
          .catch(error => { handleRequestErrors(this, error, { emailsLoaded: true }) })
      }
      else {
        this.setState({ emailsLoaded: true, showEmails: false })
      }
    }

    if (id === 0 || id === "0") {
      // `0` means this is a Reporting or Emergency User viewing the slimmed down version of the Settings page.
      // They don't need to see all Locations (and hitting it as an Emergency User would give a 401 error).
      this.setState({ locationsLoaded: true })
    }
    else {
      request('GET', '/v1/a/locations/all_locations', null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({ locations: data, locationsLoaded: true })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, locationsLoaded: true })
        })
    }
  }
}

export default withRouter(UserForm);
